import {Injectable} from '@angular/core';
import {QuestionBase} from '../models/question-base';
import {forEach} from '@angular/router/src/utils/collection';
import {TextboxQuestion} from '../models/question-textbox';
import {RadioQuestion} from '../models/question-radio';


@Injectable()
export class QuestionService {

  /**@author Lupita Llamas
   * Transform the rest array of questios to our model QuestionBase
   *
   * @param restQuestions - Rest array from ws
   * @returns {QuestionBase<any>[]} - Model
   */
  getQuestions(restQuestions) {
    const newQuestions: QuestionBase<any>[] = [];
    restQuestions.forEach(oldQuestion => {
      if (oldQuestion.type === 0) {
        const textbox = new TextboxQuestion({
          key: oldQuestion.id,
          label: oldQuestion.question,
          required: true,
        });
        newQuestions.push(textbox);
      } else {
        const newOptions = [];
        oldQuestion.options.forEach(option => {
          const aux = {key: option.answer, value: option.answer};
          newOptions.push(aux);
        });
        const radio = new RadioQuestion( {
          key: oldQuestion.id,
          label: oldQuestion.question,
          required: true,
          options: newOptions
        });
        newQuestions.push(radio);
      }
    });
    return newQuestions;
  }
}

/*
* {id: 1, options: Array [], question: "Nombre: ", type: 0},
* {id: 3, options: [{ answer: "Mujer" }, { answer: "Hombre" }], question: "Sexo: ", type: 1}
* */



// WEBPACK FOOTER //
// ./src/app/services/question.service.ts